import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../store';

const initialState = {
  widgetsOrder: [],
  widgetAiInsight: {
    show: false,
    title: '',
    value: undefined,
    widgetData: undefined,
    isRecordInsight: false,
  },
};

export const widgetChartsSlice = createSlice({
  name: 'widgetChart',
  initialState,
  reducers: {
    addWidgetsReorder: (state, action) => {
      state.widgetsOrder = action.payload;
    },
    removeWidgetsReorder: (state) => {
      state.widgetsOrder = [];
    },
    setWidgetAiInsightPanelOpened: (state, action) => {
      state.widgetAiInsight = {
        show: action.payload.show,
        title: action.payload.title,
        widgetData: action.payload.widgetData,
        value: action.payload.value,
        isRecordInsight: action.payload.isRecordInsight,
      };
    },
    setWidgetAiInsight: (state, action) => {
      state.widgetAiInsight = {
        ...state.widgetAiInsight,
        value: action.payload.value,
      };
    },
    removeWidgetAiInsight: (state) => {
      state.widgetAiInsight = {
        show: false,
        title: '',
        value: undefined,
        widgetData: undefined,
        isRecordInsight: false,
      };
    },
  },
});

export const {
  addWidgetsReorder,
  removeWidgetsReorder,
  setWidgetAiInsight,
  removeWidgetAiInsight,
  setWidgetAiInsightPanelOpened,
} = widgetChartsSlice.actions;

export default widgetChartsSlice.reducer;

export const selectWidgetChart = (state: RootState) => state.rootReducer.widgetChart;
export const selectWidgetAiInsight = (state: RootState) => state.rootReducer.widgetChart.widgetAiInsight;
